import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import Button from '~/components/Button'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import TextInput from '~/components/TextInput'
import { useUser } from '@verzekeringapp-mono/shared/src/hooks/use_user'
import useRelationMutation from '@verzekeringapp-mono/shared/src/hooks/use_relation_mutation'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { getPendingRelationMutations } from '@verzekeringapp-mono/shared/src/state/selectors/relation_mutations'

const EmailForm: React.FC = () => {
  const {
    handleSubmit,
    control,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      newEmail: '',
      repeatNewEmail: ''
    }
  })

  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)
  const { updateUser } = useUser()
  const { requestRelationMutation } = useRelationMutation()
  const pendingRelationMutations = useAppSelector(getPendingRelationMutations)
  const [feedback, setFeedback] = React.useState<string | null>(null)
  const [error, setError] = React.useState<string | null>(null)

  return (
    <form
      onSubmit={handleSubmit(async data => {
        try {
          await updateUser(
            {
              email: data.newEmail
            })

          setFeedback('Je e-mailadres is succesvol gewijzigd. Je kunt nu inloggen met je nieuwe e-mailadres.')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
          setError(err.message || 'Er is een fout opgetreden bij het wijzigen van je e-mailadres. Probeer het later opnieuw.')

          return
        }

        const confirm = window.confirm('Je hebt je e-mailadres gewijzigd om in te kunnen loggen. Wil je dat je adviseur dit ook doorvoert in je verzekeringspakket?')

        if (confirm) {
          if (pendingRelationMutations?.hasActiveRelationChange) {
            setFeedback('Er is al een wijziging in behandeling bij jouw adviseur. Je e-mailadres is wel aangepast voor inloggen in de app.')

            return
          }

          const refKey = currentResourceAuthorization?.relationInfo?.agentNumber
          const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber

          if (!refKey || !relationNumber) {
            setError('Er is iets misgegaan bij het aanvragen van de wijziging naar de adviseur. Probeer het later opnieuw.')

            return
          }

          try {
            await requestRelationMutation(refKey, relationNumber, {
              email: data.newEmail
            })
          } catch (err) {
            // do nothing
          }
        }
      })}
      className='md:w-1/2 w-full'
    >
      <Controller
        name='newEmail'
        control={control}
        render={({ field, fieldState }) => (
          <TextInput
            label='Nieuw e-mailadres'
            type='email'
            placeholder='E-mail'
            icon='envelope'
            isValid={!fieldState.invalid}
            {...field}
          />
        )}
      />

      <Controller
        name='repeatNewEmail'
        control={control}
        render={({ field, fieldState }) => (
          <TextInput
            label='Herhaal nieuw e-mailadres'
            type='email'
            placeholder='E-mail'
            icon='envelope'
            isValid={!fieldState.invalid}
            {...field}
          />
        )}
      />

      <Button
        className={`primary-btn w-full ${
          isValid ? '' : 'opacity-50'
        } mt-8 mb-3`}
        type='submit'
        disabled={!isValid}
      >
        Opslaan
      </Button>

      {
        feedback && (
          <p className='mt-4 text-center text-sm text-status-success-foreground'>
            {feedback}
          </p>
        )
      }

      {
        error && (
          <p className='mt-4 text-center text-sm text-status-danger-foreground'>
            {error}
          </p>
        )
      }
    </form>
  )
}

export default EmailForm
